import React from "react";
import type { StripePaymentElementChangeEvent } from "@stripe/stripe-js";

import { PaymentForm as PaymentFormA } from "./PaymentFormA";
import { PaymentForm as PaymentFormB } from "./PaymentFormB";

export interface PaymentFormProps {
    paymentMethodCreationError: string | null;
    handlePaymentElementChange: (event: StripePaymentElementChangeEvent) => void;
}

export function PaymentForm({ variant = "A", ...props }: { variant?: "A" | "B" } & PaymentFormProps) {
    const Component = variant === "A" ? PaymentFormA : PaymentFormB;
    return <Component {...props} />;
}
